import type { SelectOption } from '../Select';

const universities: string[] = [
  'Aalto University',
  'Aarhus University',
  'Aix Marseille University',
  'Arizona State University',
  'Australian National University (ANU)',
  'Baylor College of Medicine',
  'Beihang University',
  'Beijing Institute of Technology',
  'Beijing Normal University',
  'Boston University',
  'Brown University',
  'California Institute of Technology (Caltech)',
  'Cardiff University',
  'Carnegie Mellon University',
  'Case Western Reserve University',
  'Central South University',
  'Chalmers University of Technology',
  'Charité - Universitätsmedizin Berlin',
  'City University of Hong Kong (CityU)',
  'Columbia University',
  'Complutense University of Madrid',
  'Cornell University',
  'Curtin University',
  'Dartmouth College',
  'Delft University of Technology',
  'Duke University',
  'Durham University',
  'Ecole des Ponts ParisTech',
  'École Normale Supérieure de Lyon',
  'École Polytechnique Fédérale de Lausanne (EPFL)',
  'Eindhoven University of Technology',
  'Emory University',
  'Erasmus University Rotterdam',
  'ETH Zurich',
  'Free University of Berlin',
  'Fudan University',
  'Georgetown University',
  'Georgia Institute of Technology',
  'Ghent University',
  'Goethe University Frankfurt',
  'Hanyang University',
  'Harbin Institute of Technology',
  'Harvard University',
  'Heidelberg University',
  'Hokkaido University',
  'Huazhong University of Science and Technology',
  'Humboldt University of Berlin',
  'Hunan University',
  'Icahn School of Medicine at Mount Sinai',
  'Imperial College London',
  'Indian Institute of Technology Bombay (IITB)',
  'Indian Institute of Technology Delhi (IITD)',
  'Indiana University',
  'Indiana University Bloomington',
  'Institut Polytechnique de Paris',
  'Jilin University',
  'Johns Hopkins University',
  'Karlsruhe Institute of Technology (KIT)',
  'Karolinska Institute',
  'King Abdulaziz University (KAU)',
  'King Fahd University of Petroleum & Minerals',
  'King Saud University',
  "King's College London",
  'Korea Advanced Institute of Science and Technology (KAIST)',
  'Korea University',
  'KTH Royal Institute of Technology',
  'KU Leuven',
  'Kyoto University',
  'Kyushu University',
  'Lancaster University',
  'Leiden University',
  'London School of Hygiene & Tropical Medicine',
  'Lund University',
  'Maastricht University',
  'Macquarie University',
  'Massachusetts Institute of Technology (MIT)',
  'Mayo Clinic Alix School of Medicine',
  'McGill University',
  'McMaster University',
  'Michigan State University',
  'Monash University',
  'Moscow State University',
  'Nagoya University',
  'Nanjing University',
  'Nankai University',
  'Nanyang Technological University (NTU)',
  'National Taiwan University',
  'National University of Singapore (NUS)',
  'New York University (NYU)',
  'Newcastle University',
  'Northwestern Polytechnical University',
  'Northwestern University',
  'Norwegian University of Science and Technology (NTNU)',
  'Osaka University',
  'Paris Sciences et Lettres University (PSL)',
  'Paris-Saclay University',
  'Peking University',
  'Pennsylvania State University',
  'Pohang University of Science and Technology (POSTECH)',
  'Politecnico di Milano',
  'Pontificia Universidad Católica de Chile (UC)',
  'Princeton University',
  'Purdue University',
  'Qatar University',
  'Queen Mary University of London',
  'Queensland University of Technology (QUT)',
  'Radboud University Nijmegen',
  'Rice University',
  'RMIT University',
  'Rockefeller University',
  'Rutgers University, New Brunswick',
  'RWTH Aachen University',
  'Sapienza University of Rome',
  'Scuola Normale Superiore di Pisa',
  'Seoul National University',
  'Shandong University',
  'Shanghai Jiao Tong University',
  'Shenzhen University',
  'Sichuan University',
  'Soochow University',
  'Sorbonne University',
  'South China University of Technology',
  'Southeast University',
  'Southern University of Science and Technology',
  'Stanford University',
  'Stockholm University',
  'Sun Yat-sen University',
  'Sungkyunkwan University (SKKU)',
  'Technical University of Berlin',
  'Technical University of Denmark',
  'Technical University of Munich',
  'Technion-Israel Institute of Technology',
  'Technische Universität Wien',
  'Tecnológico de Monterrey',
  'Texas A&M University',
  'The Chinese University of Hong Kong (CUHK)',
  'The Hebrew University of Jerusalem',
  'The Hong Kong Polytechnic University (PolyU)',
  'The Hong Kong University of Science and Technology (HKUST)',
  'The London School of Economics and Political Science (LSE)',
  'The Ohio State University',
  'The University of Adelaide',
  'The University of Auckland',
  'The University of Chicago',
  'The University of Edinburgh',
  'The University of Hong Kong (HKU)',
  'The University of Manchester',
  'The University of Melbourne',
  'The University of New South Wales (UNSW Sydney)',
  'The University of Newcastle, Australia (UoN)',
  'The University of North Carolina at Chapel Hill',
  'The University of Queensland',
  'The University of Sydney (USYD)',
  'The University of Texas at Austin',
  'The University of Texas MD Anderson Cancer Center',
  'The University of Texas Southwestern Medical Center',
  'The University of Tokyo',
  'The University of Warwick',
  'The University of Western Australia',
  'Tianjin University',
  'Tohoku University',
  'Tokyo Institute of Technology (Tokyo Tech)',
  'Tongji University',
  'Trinity College Dublin, The University of Dublin',
  'Tsinghua University',
  'TU Dresden',
  'Tufts University',
  'Ulm University',
  'Ulsan National Institute of Science and Technology (UNIST)',
  'Universidad Autónoma de Madrid',
  'Universidad de Buenos Aires (UBA)',
  'Universidad de Chile',
  'Universidad de los Andes',
  'Universidad Nacional Autónoma de México (UNAM)',
  'Universitat Autònoma de Barcelona',
  'Université catholique de Louvain (UCLouvain)',
  'Université Grenoble Alpes',
  'Universite libre de Bruxelles (ULB)',
  'Université Paris Cité',
  'Universiti Kebangsaan Malaysia (UKM)',
  'Universiti Malaya (UM)',
  'Universiti Putra Malaysia (UPM)',
  'Universiti Sains Malaysia (USM)',
  'Universiti Teknologi Malaysia',
  'University College Dublin',
  'University College London (UCL)',
  'University of Alberta',
  'University of Amsterdam',
  'University of Antwerp',
  'University of Arizona',
  'University of Barcelona',
  'University of Basel',
  'University of Bath',
  'University of Bern',
  'University of Birmingham',
  'University of Bologna',
  'University of Bonn',
  'University of Bristol',
  'University of British Columbia',
  'University of Calgary',
  'University of California, Berkeley',
  'University of California, Davis',
  'University of California, Irvine',
  'University of California, Los Angeles',
  'University of California, San Diego',
  'University of California, San Francisco',
  'University of California, Santa Barbara',
  'University of California, Santa Cruz',
  'University of Cambridge',
  'University of Cape Town',
  'University of Cologne',
  'University of Colorado Boulder',
  'University of Copenhagen',
  'University of Electronic Science and Technology of China',
  'University of Erlangen-Nuremberg',
  'University of Exeter',
  'University of Florida',
  'University of Freiburg',
  'University of Geneva',
  'University of Glasgow',
  'University of Gothenburg',
  'University of Göttingen',
  'University of Groningen',
  'University of Hamburg',
  'University of Helsinki',
  'University of Illinois at Urbana-Champaign',
  'University of Lausanne',
  'University of Leeds',
  'University of Liverpool',
  'University of Macau',
  'University of Mannheim',
  'University of Maryland, College Park',
  'University of Massachusetts',
  'University of Massachusetts Amherst',
  'University of Michigan',
  'University of Michigan-Ann Arbor',
  'University of Milan',
  'University of Minnesota',
  'University of Montpellier',
  'University of Montreal',
  'University of Munich',
  'University of Münster',
  'University of Notre Dame',
  'University of Nottingham',
  'University of Oslo',
  'University of Ottawa',
  'University of Oxford',
  'University of Padua',
  'University of Pennsylvania',
  'University of Pisa',
  'University of Pittsburgh',
  'University of Reading',
  'University of Rochester',
  'University of Sao Paulo',
  'University of Science and Technology of China',
  'University of Sheffield',
  'University of Southampton',
  'University of Southern California',
  'University of St Andrews',
  'University of Strasbourg',
  'University of Technology Sydney (UTS)',
  'University of Toronto',
  'University of Tuebingen',
  'University of Twente',
  'University of Utah',
  'University of Vienna',
  'University of Virginia',
  'University of Washington',
  'University of Waterloo',
  'University of Wisconsin - Madison',
  'University of Wollongong',
  'University of Würzburg',
  'University of York',
  'University of Zurich',
  'Uppsala University',
  'Utrecht University',
  'Vanderbilt University',
  'Vrije Universiteit Amsterdam',
  'Wageningen University & Research',
  'Waseda University',
  'Washington University in St. Louis',
  'Weizmann Institute of Science',
  'Western University',
  'Wuhan University',
  'Xiamen University',
  `Xi'an Jiaotong University`,
  'Yale University',
  'Yonsei University',
  'Zhejiang University',
  'Zhengzhou University',
];

export const convertToSelectOptions = (
  universities: string[],
): SelectOption[] => {
  return universities.map(university => ({
    value: university,
    label: university,
  }));
};

export const universitiesList: SelectOption[] =
  convertToSelectOptions(universities);
